import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';

import { useBackerApi } from '../../../api';
import { backerKeys } from '../../../query-key-factory';
import { CauseSubscriptionResponse } from './subscription.types';

const useGetBackerConsumerCauseSubscriptions = () => {
  const BackerApi = useBackerApi();

  const ShowBackerConsumerCauseSubscriptions = useCallback(async () => {
    const { data } = await BackerApi.get<CauseSubscriptionResponse>(
      '/consumer/backer/cause_subscriptions'
    );
    return data.cause_subscriptions;
  }, [BackerApi]);

  return ShowBackerConsumerCauseSubscriptions;
};

const useShowBackerConsumerCauseSubscriptions = () => {
  const getBackerConsumerCauseSubscriptions = useGetBackerConsumerCauseSubscriptions();

  return useQuery({
    queryKey: backerKeys.consumer.backer.subscriptions.all,
    queryFn: getBackerConsumerCauseSubscriptions,
  });
};

export { useShowBackerConsumerCauseSubscriptions };
